import { useSearchParams } from "react-router-dom";
import { Table } from "../../../../../../components/Functional";
import { Button, Modal } from "../../../../../../components/ui";
import { FETCH_EXHIBITION_DOCUMENTS } from "../../../../../../graphql/query/ExhibitionDocument";
import SectionHeader from "../../components/SectionHeader";
import Actions from "./components/Actions";
import AddDocuments from "./components/AddDocument";
import {
  DOCUMENT_FILE_NAME_LABEL_CLASS,
  DOCUMENT_HIGHLIGHT_ROW_CLASS,
  matchesDocumentFilename,
} from "../../../../../../util/documentLink";

const Documents = props => {
  const { exhibition, exhibitionId } = props || {};
  const [searchParams] = useSearchParams();
  const highlightedFilename = searchParams.get("filename");

  const tableProps = {
    variant: "dynamicHeight",
    dataKey: "exhibitionDocuments",
    headers: [
      {
        label: "File Name",
        name: "fileName",
        type: "label",
        labelClass: DOCUMENT_FILE_NAME_LABEL_CLASS,
        widthInPx: 360,
        width: "45%",
      },
      { label: "File Type", name: "fileType", type: "label" },
      { label: "Date", name: "updatedAt", type: "date" },
      {
        label: "",
        name: "action",
        type: "custom",
        component: Actions,
      },
    ],
    inputs: [{ label: "Name", name: "name", type: "type", view: "partial" }],
    FETCH_QUERY: FETCH_EXHIBITION_DOCUMENTS,
    variables: {
      exhibitionId: +exhibitionId,
    },
    className: "sm:px-0 lg:px-0",
    rowClassName: values =>
      matchesDocumentFilename(values?.fileName, highlightedFilename)
        ? DOCUMENT_HIGHLIGHT_ROW_CLASS
        : "",
  };

  const modalProps = {
    body: AddDocuments,
    closeOnBackdrop: true,
    exhibition,
    hideCloseButton: true,
    scale: "md",
  };

  const actions = [
    {
      component: () => (
        <Modal {...modalProps}>
          <Button label="Upload" action="black" />
        </Modal>
      ),
    },
  ];

  return (
    <div className="w-full">
      <SectionHeader title="Documents" actions={actions} />
      <div className="mb-6 w-full">
        <Table {...tableProps} />
      </div>
    </div>
  );
};

export default Documents;
